import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Api } from '../api';



export const expiredGuard: CanActivateFn = async (route, state) => {
  const api = inject(Api);
  const router = inject(Router);

  const redirect = await api.getViewForApiResult();
  if (redirect == "expired") {
    return true
  }

  router.navigate(["/", redirect])
  return false
};
